import React from 'react';

import useInvoices from 'components/Common/VoluntaryBenefits/Hooks/useInvoices';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import Table from 'components/new_ui/Table';

import columns from './Invoices/columns';

export default function Invoices() {
  const invoices = useInvoices();

  if (invoices === null) {
    return (
      <LoadingPlaceholder text="Loading..." className="py-5" />
    );
  }

  const rowActions = [
    {
      title: 'Download',
      type: 'CUSTOM',
      iconClass: 'download-icon',
      href: (row) => row.attributes.report_url,
    },
  ];

  return (
    <>
      <h4 className="mt-3">Invoices</h4>

      <Table
        columns={columns}
        data={invoices}
        selectableRows={false}
        rowActions={rowActions}
      />

    </>
  );
}
